<template>
  <div class="real-message-content" v-loading="loading" v-infinite-scroll="load" :infinite-scroll-distance="20">
    <template >
      <div class="message" >
        <div class="filter">
          <DatePan @change="changeTime" v-model="timeArr" :shortcuts="shortcuts" :picker-options="pickerOptions"></DatePan>
          <Opation v-model="params.order_is_read" @change="changeOpation" v-if="!isNull"></Opation>
          <RealBtn @click.native="readAll" v-if="!isNull"></RealBtn>
        </div>
        <template v-if="!isNull">
          <div class="message-iem" v-for="(item, key) in dataset" :key="key">
            <div class="title">{{resetTime(key)}}</div>
            <div class="tap" v-for="temp in item" :key="temp.id" :class="{[temp.is_read ? 'is-real' : 'not-real']: true}" @click="tapClick(temp)">
              <div class="ava">
                <MyAvatar :userName="temp.message_sender_user.realname" :imgUrl="temp.message_sender_user.user_avatar" width="30px" height="30px">{{temp.message_sender_user.realname}}</MyAvatar>
                <span class="time">{{resetTime(temp.create_time)}}</span>
              </div>
              <div class="real-notice message-model" v-html="getTaskModel(temp)" @click.stop="messageHasClick($event,temp)"></div>
              <div class="real-tip">
                <!-- 跨团队项目 -->
                <span v-if="temp.cross_projects" class="text-blue" @click.stop="openMessageCrossProject(temp)">
                  <i class="icon iconfont iconicon_action_item"></i>
                  {{temp.cross_projects.project_name}}
                </span>

                <!-- 项目 -->
                <span v-if="temp.project" class="text-blue" @click.stop="openMessageTaskProject(temp)">
                  <span v-if="temp.cross_projects" style="margin-right: 8px;margin-left: 6px;">/</span>
                  <i class="icon iconfont iconicon_action_item"></i>
                  {{temp.project.title}}
                </span>

                <!-- 任务 -->
                <span v-if="temp.task" class="text-blue" :class="{'not-click': temp.raw_data.action === 'delete_task'}" @click.stop="openMessageTask(temp)">
                  <span style="margin-right: 8px;margin-left: 6px;">/</span>
                  <i class="icon iconfont iconicon_task_message2"></i>
                  {{temp.task.task_name}}
                </span>

                <!-- 里程碑 -->
                <span v-if="temp.cross_projects_milestone" class="text-blue" @click.stop="openMessageCrossProject(temp)">
                  <span style="margin-right: 8px;margin-left: 6px;">/</span>
                  <i class="icon iconfont iconicon_task_message2"></i>
                  {{temp.cross_projects_milestone.milestone_name}}
                </span>
              </div>
              <span class="real-icon tableIconHover" @click.stop="readMessage(temp)"><i class="icon iconfont iconicon_selected_more_task"></i>设为已读</span>
            </div>
          </div>
          <div class="loading-box" v-if="isLoading">
            <i class="el-icon-loading"></i>
            <span>载入中...</span>
          </div>
        </template>
      </div>
    </template>
    <nothing v-if="!loading && Object.keys(dataset).length === 0 && isHas" :config="{tip: '暂无消息通知'}"></nothing>
  </div>
</template>
<script>

import MyAvatar from '@/components/avatar'
import api from '@/services/api/realMessage/realMessage'
import DatePan from '@/components/taskFilterBox/date'
import RealBtn from './filterBox/realBtn'
import Opation from './filterBox/opation'
export default {
  props: ['message_type', 'project_id', 'message_label', 'cross_project_id'],
  components: {
    RealBtn,
    Opation,
    DatePan,
    MyAvatar
  },
  data() {
    return {
      params: {
        page: 0,
        per_page: 25,
        message_type: 0,
        start_time: '',
        end_time: '',
        order_is_read: 1,
        project_id: '',
        cross_project_id: ''
      },
      dataset: {},
      loading: false,
      isLoading: false,
      isFinish: false,
      isHas: false,
      timeArr: [],
      shortcuts: [{
        text: '清空',
        cellClassName:'date-cancel del-text text-red',
        onClick(picker) {
          picker.$emit('pick', '');
        }
      }],
      pickerOptions: {
        disabledDate(time) {
          // 获取当前日期
          const today = new Date();
          // 将今天之前的日期禁用
          return time.getTime() > today.getTime();
        }
      }
    }
  },
  watch: {
    message_type: {
      handler() {
        this.params.message_type = this.message_type
        this.reset()
      }
    },
    project_id: {
      handler() {
        this.params.project_id = this.project_id
      },
      immediate: true
    },
    cross_project_id: {
      handler() {
        this.params.cross_project_id = this.cross_project_id
      },
      immediate: true
    },
  },
  computed: {
    isNull() {
      return Object.keys(this.dataset).length == 0
    },
    isHav() {
      let arr = [4, 5, 6, 101]
      return arr.indexOf(this.message_type) > -1
    }
  },
  created() {
    // this.init()
  },
  methods: {
    async init() {
      this.loading = true
      let result = await api.historyMessageLogs(this.params)
      this.isHas = true
      this.filterArr(result.data)
      this.loading = false
    },
    filterArr(result) {
      if(this.params.order_is_read === 0) {
        result.forEach(res => {
          let time = res.create_time.split(' ')[0]
          if(this.dataset[time]) {
            this.dataset[time].push(res)
          } else {
            this.$set(this.dataset, time, [res])
          }
        })
      } else {
        result.forEach(res => {
          let type = res.is_read === 0 ? '未读' : '已读'
          if(this.dataset[type]) {
            this.dataset[type].push(res)
          } else {
            this.$set(this.dataset, type, [res])
          }
        })
      }
    },
    async readMessage(temp) {
      await api.setMessageRead({message_id: temp.id, one_click_read: 0})
      this.$set(temp, 'is_read', 1)
      this.$emit('reset')
    },
    async readAll() {
      await api.setMessageRead({one_click_read: 1, project_id: this.project_id, cross_project_id: this.cross_project_id, message_type: this.message_type})
      this.$emit('reset')
      this.reset()
    },
    changeTime(val) {
      this.params.start_time = val[0]
      this.params.end_time = val[1]
      this.$emit('changeTime', val)
      this.reset()
    },
    async load() {
      if(this.isLoading || this.isFinish || this.loading) return
      this.isLoading = true
      this.params.page = this.params.page + 1
      let result = await api.historyMessageLogs(this.params)
      this.filterArr(result.data)
      this.isHas = true
      this.isLoading = false
      if(result && result.data.length === 0) {
        this.isFinish = true
      }
    },
    changeOpation() {
      this.reset()
    },
    reset() {
      this.params.page = 1
      this.params.per_page = 25
      this.isLoading = false
      this.isFinish = false
      this.dataset = {}
      this.$nextTick(() => {
        this.init()
      })
    },
    tapClick(item) {
      this.readMessage(item)
      this.$nextTick(() => {
        this.openMessageTypeLink(item)
      })
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/mixin.scss';
.real-message-content {
   display: flex;
   justify-content: center;
   position: relative;
   width: 100%;
   height: 100%;
   overflow-x: hidden;
   overflow: overlay;
   margin-top: -2px;
  .head {
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }
  .filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: fixed;
    top: 69px;
    width: 1080px;
    z-index: 101;
    &> div{
      margin-left: 8px;
    }
  }
  .message {
    width: 1080px;
    position: relative;
    .loading-box {
      text-align: center;
      font-size: 14px;
      height: 30px;
      line-height: 30px;
      span {
        margin-left: 10px;
      }
    }
    .real-notice {
      display: inline-flex;
      padding-left: 40px;
      width: 100%;
      box-sizing: border-box;
    }
    .real-tip {
      // display: flex;
      // align-items: center;
      font-size: 12px;
      color: rgba(32, 32, 32, 0.6);
      padding-left: 40px;
      margin-top: 16px;
      padding-right: 100px;
      @include ellipsis(1);
      i {
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .tap {
      padding: 16px 24px;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      position: relative;
      cursor: pointer;
      &:hover {
        background-color: rgba(32, 32, 32, 0.04);
      }
    }
    .not-real {
      &:hover {
        .real-icon {
          display: inline;
        }
      }
    }
    .is-real {
      opacity: 0.4;
    }
    .real-icon {
      color: rgba(32, 32, 32, 0.6);
      font-size: 14px;
      display: flex;
      align-items: center;
      display: none;
      position: absolute;
      right: 24px;
      bottom: 14px;
      i {
        font-size: 14px;
        margin-right: 8px;
      }
    }
    .ava {
      font-size: 14px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .time {
        color: rgba(32, 32, 32, 0.6);
        font-size: 14px;
        font-weight: 400;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      padding: 24px 0;
      position: sticky;
      top: 0;
      background-color: #fff;
      z-index: 100;
    }
    .message-line-box:not(:first-child) {
      margin-top: 16px;
    }
  }
}
</style>
